<template>
  <div class="discount-page">
    <!-- Header -->
    <header class="header">
      <div class="back-button" @click="goBack">
        <el-icon><ArrowLeft /></el-icon>
      </div>
      <div class="title">停车找优惠</div>
      <div class="more-button">
        <el-icon><MoreFilled /></el-icon>
      </div>
    </header>
    <div class="website">www.deepark.com.cn</div>

    <!-- Limited Time Offers -->
    <!-- <div class="limited-offers">
      <div class="offer-header">
        <div class="offer-label">限时秒杀</div>
        <div class="countdown">
          <div class="countdown-number">{{ countdown.hours }}</div>
          <div class="countdown-separator">:</div>
          <div class="countdown-number">{{ countdown.minutes }}</div>
          <div class="countdown-separator">:</div>
          <div class="countdown-number">{{ countdown.seconds }}</div>
        </div>
        <div class="next-round">{{ nextRoundTime }}场</div>
      </div>

      <div class="time-slots">
        <div
          v-for="(slot, index) in timeSlots"
          :key="index"
          class="time-slot"
          :class="{ active: slot.isActive }"
        >
          <div class="time">{{ slot.time }}</div>
          <div class="status">{{ slot.status }}</div>
        </div>
      </div> -->

    <!-- Coupon Cards -->
    <!-- <div class="coupon-container">
      <div
        v-for="(coupon, index) in flashSaleCoupons"
        :key="index"
        class="coupon-card"
        :class="getCouponTypeClass(coupon.type)"
      >
        <div class="coupon-tag">{{ getCouponTag(coupon) }}</div>
        <div class="rules-link" @click="showRules(coupon)">规则 &gt;</div>
        <div class="coupon-value" v-if="coupon.type === 'cash'">
          <span class="value-number">{{ coupon.value }}</span>元 x
          <span class="value-quantity">{{ coupon.quantity }}</span>张
        </div>
        <div class="coupon-value" v-else-if="coupon.type === 'percent'">
          {{ coupon.value }}<span class="discount-unit">折</span>
        </div>
        <div class="coupon-value" v-else-if="coupon.type === 'duration'">
          {{ coupon.value }}小时停车券
        </div>
        <div class="coupon-desc" v-for="(desc, dIndex) in coupon.descriptions" :key="dIndex">{{ desc }}</div>
        <div class="grab-button" @click="purchaseCoupon(coupon)">{{ coupon.distributionPrice }}元抢购</div>
      </div>
  </div> -->

    <!-- Search Bar -->
    <div class="search-container">
      <div class="search-box">
        <el-icon><Search /></el-icon>
        <input type="text" class="search-input" placeholder="输入目的地，搜停车优惠" v-model="searchText">
        <div class="search-button" @click="parkingSearch">搜索</div>
      </div>

      <div class="view-toggle">
        <div :class="{ 'hidden': isMapView }" @click="setMapView(false)">
          <img src="../assets/icons/list.png" height="26" width="26"/>
          <br/>
          <div class="icon-label">列表</div>
        </div>
        <div :class="{ 'hidden': !isMapView }" @click="setMapView(true)">
          <img src="../assets/icons/map.png" height="23" width="23"/>
          <br/>
          <div class="icon-label">地图</div>
        </div>
      </div>
<!--      <div class="map-button" @click="goToDiscountMap(true)">-->
<!--        <el-icon><Location /></el-icon>-->
<!--        <span>优惠地图</span>-->
<!--      </div>-->
    </div>

    <!-- Nearby Discounts and Current Location -->
    <div class="location-info">
      <div class="location-left">
        <el-icon><Location /></el-icon>
        <span>附近停车优惠</span>
      </div>
      <div class="location-right" v-if="currentAddress">
        {{ currentAddress }}
      </div>
    </div>

    <!-- Map -->
    <div class="map-container" id="mapContainer" v-show="!isMapView"></div>

    <!-- Coupon List -->
    <ParkingDiscounts
        ref="parkingDiscountsRef"
        :user-location="userLocation"
        :search-query="searchText"
        @handle-coupon-action="handleCouponAction"
    />

    <!-- Debug Panel -->
    <div v-if="isDevelopment" class="debug-panel">
<!--      {{userLocation}}-->
      <p>Location Status: {{userLocation ? '✅ 已获取' : '❌ 未获取'}}</p>
      <p v-if="userLocation">经度: {{userLocation.longitude}}, 纬度: {{userLocation.latitude}}</p>
      <p v-if="userLocation && userLocation.latitude === 31.9522">📍 使用默认位置 (南京)</p>
      <el-button size="small" @click="retryGetLocation">重试获取位置</el-button>
      <el-button size="small" @click="refreshDiscountList">刷新优惠列表</el-button>
    </div>
</div>

<!-- Use the AppFooter component -->
<AppFooter />

<!--&lt;!&ndash; Rules Dialog &ndash;&gt;-->
<!--<el-dialog v-model="rulesDialogVisible" title="优惠券使用规则" width="80%">-->
<!--  <div v-if="selectedCoupon">-->
<!--    <h3>{{ selectedCoupon.templateName }}</h3>-->
<!--    <p>有效期：{{ formatDate(selectedCoupon.validStartTime) }} 至 {{ formatDate(selectedCoupon.validEndTime) }}</p>-->
<!--    <div v-html="selectedCoupon.useRules || '暂无详细规则'"></div>-->
<!--  </div>-->
<!--</el-dialog>-->
</template>

<script>
/* eslint-disable no-unused-vars */
import {ref, onMounted, computed, reactive, nextTick} from 'vue'
import { useRouter } from 'vue-router'
import { ArrowLeft, Search, Location, MoreFilled } from '@element-plus/icons-vue'
import AppFooter from '@/components/AppFooter.vue'
import { listPublicCoupons, getNearByCoupons, getFlashSaleCoupons, purchaseCoupon } from '@/api/coupon/couponRelease'
import { ElMessage, ElMessageBox } from 'element-plus'
import { populateBusiEntityNames } from '@/utils/couponUtils'
import ParkingDiscounts from "@/components/ParkingDiscounts/index.vue";
/* eslint-enable no-unused-vars */

export default {
  components: {
    ParkingDiscounts,
    ArrowLeft,
    Search,
    Location,
    MoreFilled,
    AppFooter
  },
  methods: {
    // onHandleCouponAction(coupon) {
    //   console.log('Parent received coupon action:', coupon);
    //
    //   if (!coupon) {
    //     console.error('No coupon data provided');
    //     return;
    //   }
    //
    //   // For free coupons (price is 0)
    //   if (!coupon.distributionPrice || parseFloat(coupon.distributionPrice) === 0) {
    //     this.receiveCoupon(coupon);
    //   }
    //   // For paid coupons (price > 0)
    //   else {
    //     console.log('Navigating to payment page with:', {
    //       couponId: coupon.id,
    //       price: coupon.distributionPrice,
    //       type: 'coupon'
    //     });
    //
    //     this.$router.push({
    //       name: 'PaymentConfirm',
    //       query: {
    //         couponId: coupon.id,
    //         price: coupon.distributionPrice,
    //         type: 'coupon'
    //       }
    //     });
    //   }
    // }
  },
  setup() {
    const router = useRouter()

    // Template refs
    const parkingDiscountsRef = ref(null)

    // Data
    const loading = ref(false)
    // const flashSaleCoupons = ref([])
    const nearbyCoupons = ref([])
    const currentAddress = ref('南京市江宁区潭园西路128号')
    const rulesDialogVisible = ref(false)
    const isMapView = ref(true)
    const markers = ref([])
    const map = ref(null);
    const searchText = ref('')
    // const selectedCoupon = ref(null)

    // Countdown timer
    const countdown = reactive({
      hours: '03',
      minutes: '25',
      seconds: '20'
    })

    // Time slots
    const timeSlots = ref([
      { time: '18:00', status: '即将开抢', isActive: false },
      { time: '00:00', status: '即将开抢', isActive: false },
      { time: '06:00', status: '即将开抢', isActive: true }
    ])

    const nextRoundTime = ref('12:00')

    // const refreshKey = ref(0)
    // Make sure userLocation is properly initialized
    const userLocation = ref(null)

    // Add this computed property for development mode detection
    const isDevelopment = computed(() => {
      // Check if we're in development mode (could use process.env or other methods)
      return process.env.NODE_ENV === 'development';
    });

    // // Computed property to group coupons by business entity
    // const groupedCoupons = computed(() => {
    //   const groups = {}
    //
    //   nearbyCoupons.value.forEach(coupon => {
    //     const key = `${coupon.businessType}_${coupon.busiEntityId}`
    //
    //     if (!groups[key]) {
    //       groups[key] = {
    //         businessType: coupon.businessType,
    //         busiEntityId: coupon.busiEntityId,
    //         entityName: coupon.entityName || '未知场所',
    //         distance: coupon.distance || '未知距离',
    //         coupons: [],
    //         mainCoupon: null,
    //         totalCoupons: 0,
    //         claimedCount: Math.floor(Math.random() * 200) + 50 // Mock claimed count for now
    //       }
    //     }
    //
    //     groups[key].coupons.push(coupon)
    //     groups[key].totalCoupons++
    //
    //     // Set the main coupon (best one) for display
    //     if (!groups[key].mainCoupon || isBetterCoupon(coupon, groups[key].mainCoupon)) {
    //       groups[key].mainCoupon = coupon
    //     }
    //   })
    //
    //   return Object.values(groups)
    // })

    // // Check if one coupon is better than another
    // const isBetterCoupon = (coupon1, coupon2) => {
    //   // Prioritize by type and value
    //   if (coupon1.type === 'cash' && coupon2.type === 'cash') {
    //     return coupon1.value > coupon2.value
    //   } else if (coupon1.type === 'percent' && coupon2.type === 'percent') {
    //     return coupon1.value < coupon2.value // Lower percentage is better
    //   } else if (coupon1.type === 'duration' && coupon2.type === 'duration') {
    //     return coupon1.value > coupon2.value
    //   }
    //
    //   // Default priority: cash > percent > duration
    //   const typePriority = { 'cash': 1, 'percent': 2, 'duration': 3 }
    //   return typePriority[coupon1.type] < typePriority[coupon2.type]
    // }

    // // Fetch flash sale coupons
    // const fetchFlashSaleCoupons = async () => {
    //   try {
    //     const response = await getFlashSaleCoupons();
    //     if (response && response.rows) {
    //       flashSaleCoupons.value = response.rows;
    //     }
    //   } catch (error) {
    //     console.error('Error fetching flash sale coupons:', error);
    //   }
    // }

    // // Fetch nearby coupons
    // const fetchNearbyCoupons = async () => {
    //   loading.value = true;
    //
    //   try {
    //     let response;
    //
    //     if (userLocation.value?.latitude && userLocation.value?.longitude) {
    //       // Use location if available
    //       const { latitude, longitude } = userLocation.value;
    //       console.log('Fetching nearby coupons with location:', { latitude, longitude });
    //       response = await getNearByCoupons(latitude, longitude, 5000);
    //     } else {
    //       // Fallback to all public coupons
    //       console.log('Fetching all public coupons (no location)');
    //       response = await listPublicCoupons();
    //     }
    //
    //     console.log('API response:', response);
    //
    //     if (response && response.rows) {
    //       // Important: Populate entity names before updating the reactive data
    //       const processedCoupons = await populateBusiEntityNames(response.rows);
    //
    //       // Now update the reactive data
    //       nearbyCoupons.value = processedCoupons;
    //       console.log('Processed coupons with entity names:', nearbyCoupons.value);
    //     } else {
    //       nearbyCoupons.value = [];
    //       console.log('No coupons data found in response');
    //     }
    //   } catch (error) {
    //     console.error('Error fetching nearby coupons:', error);
    //     ElMessage.error('获取优惠券数据失败');
    //     nearbyCoupons.value = [];
    //   } finally {
    //     loading.value = false;
    //   }
    // };

    // // Helper functions for coupon data
    // const getCouponTypeFromTemplate = (item) => {
    //   // First try to use typeId directly
    //   if (item.typeId) return item.typeId;
    //
    //   // Otherwise try to infer from template name or other data
    //   if (item.name && typeof item.name === 'string') {
    //     if (item.name.includes('折')) return 2; // Discount percentage
    //     if (item.name.includes('元')) return 1; // Cash amount
    //   }
    //
    //   // Default to cash amount
    //   return 1;
    // }

    // // const getCouponValueFromTemplate = (item) => {
    // //   // First try to use discountValue directly
    // //   if (item.discountValue !== undefined && item.discountValue !== null) {
    // //     return item.discountValue;
    // //   }
    // //
    // //   // Otherwise try to extract from name or other fields
    // //   if (item.templateValue !== undefined && item.templateValue !== null) {
    // //     return item.templateValue;
    // //   }
    // //
    // //   return 0;
    // // }
    //
    // // Format helpers
    // const formatDistance = (distance) => {
    // //   if (distance === undefined || distance === null) return '';
    // //   if (typeof distance === 'string') return distance;
    // //
    // //   // Convert to appropriate units
    // //   if (distance < 1) {
    // //     return `${Math.round(distance * 1000)}米`;
    // //   }
    // //   return `${distance.toFixed(1)}公里`;
    // // }



    const formatDate = (date) => {
      if (!date) return ''
      const d = new Date(date)
      return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
    }

    const formatCouponValue = (coupon) => {
      if (!coupon) return ''
      if (coupon.type === 'cash') return `¥${coupon.value.toFixed(2)}`
      if (coupon.type === 'percent') return coupon.value
      if (coupon.type === 'duration') return `${coupon.value}小时`
      return ''
    }

    // UI helper functions
    const getCouponTypeClass = (type) => {
      return {
        'coupon-cash': type === 'cash',
        'coupon-percent': type === 'percent',
        'coupon-duration': type === 'duration'
      }
    }

    const getCouponTypeColor = (type) => {
      return {
        'discount-cash': type === 'cash',
        'discount-percent': type === 'percent',
        'discount-duration': type === 'duration'
      }
    }

    const getCouponBusinessClass = (type) => {
      return {
        'business-parking': type === 1,
        'business-charging': type === 2,
        'business-washing': type === 3
      }
    }

    const getBusinessLabel = (type) => {
      switch (type) {
        case 1: return '停车'
        case 2: return '充电'
        case 3: return '洗车'
        default: return '优惠'
      }
    }

    const getCouponTag = (coupon) => {
      if (coupon.businessType === 2) return '送充电券'
      if (coupon.businessType === 3) return '送洗车券'
      if (coupon.type === 'duration') return '送时长券'
      return '送优惠券'
    }

    // Action functions
    const goBack = () => {
      router.push({ name: 'Home' })
    }

    const goToSearch = () => {
      router.push({ name: 'DiscountSearch' })
    }

    const updateParkingMarkers = () => {
      const coupons = parkingDiscountsRef.value.nearbyCoupons;
      console.log(11111, coupons);

      // Add markers for each parking space
      Object.values(coupons).forEach(coupon => { // Fixed: parkingSpaces.value → Object.values(parkingSpaces)
        if (coupon.latitude && coupon.longitude) {
          const position = new window.T.LngLat(coupon.longitude, coupon.latitude);
          const marker = new window.T.Marker(position);
          marker.spaceId = coupon.busiEntityId;

          // Set icon based on availability
          const isAvailable = true;  //space.availableSpots > 0;
          marker.setIcon(new window.T.Icon({
            iconUrl: require(`@/assets/images/parking-${isAvailable ? 'available' : 'full'}.png`),
            iconSize: new window.T.Point(32, 32),
            iconAnchor: new window.T.Point(24, 24)
          }));

          // // Add click event
          // marker.addEventListener('click', async () => {
          //   packageSpots.value = allSpots.value.filter(spot => spot.parkingSpaceId === space.spaceId);
          //   await nextTick();
          //   selectedParkingSpace.value = space.spaceId;
          // });

          // Add hover events
          // marker.addEventListener('mouseover', () => {
          //   marker.openInfoWindow(infoWindow);
          // });
          //
          // marker.addEventListener('mouseout', () => {
          //   marker.closeInfoWindow();
          // });

          // Add to map and store reference
          map.value.addOverLay(marker);
          markers.value.push(marker);
        }
      });
    }

    const setMapView = async (value) => {
      // router.push({ name: 'DiscountMap' })
      console.log("display map")
      isMapView.value = !value
      if(!isMapView.value)
      {
        await nextTick();
        await loadTiandituAPI();

        // Clear existing markers
        markers.value.forEach(marker => {
          map.value.removeOverLay(marker);
        });
        markers.value = [];

        updateParkingMarkers();
      }
      else{
        // selectedParkingSpace.value = null;
        // packageSpots.value = allSpots.value;
      }
    }

    const loadTiandituAPI = async () => {
      // Check if Tianditu API is already loaded
      if (window.T) {
        await initMap();
        return;
      }

      // Load Tianditu API script
      const script = document.createElement('script');
      script.type = 'text/javascript';
      const tiandituKey = 'your-tianditu-key';
      script.src = `https://api.tianditu.gov.cn/api?v=4.0&tk=${tiandituKey}`;

      script.onload = async () => {
        await initMap();
      };

      script.onerror = () => {
        this.$message.error('加载地图API失败，请刷新页面重试');
      };

      document.head.appendChild(script);
    }

    const initMap = () => {
      // Create map instance - use window.T since we loaded it globally
      map.value = new window.T.Map('mapContainer');

      // Set initial center and zoom level
      const center = new window.T.LngLat(
          userLocation.value.longitude,
          userLocation.value.latitude
      );
      map.value.centerAndZoom(center, 13);

      // Add controls
      map.value.addControl(new window.T.Control.Zoom());
      // map.value.addControl(new window.T.Control.Scale());
      // map.value.addControl(new window.T.Control.MapType());

      // Enable interactions
      map.value.enableDrag();
      map.value.enableScrollWheelZoom();
      map.value.enableDoubleClickZoom();

      // Add current location marker
      addCurrentLocationMarker();
    };

    const parkingSearch=()=>{
      parkingDiscountsRef.value.triggerSearch(searchText.value);
    };

    const addCurrentLocationMarker = () => {
      // Create current location marker
      const center = new window.T.LngLat(
          userLocation.value.longitude,
          userLocation.value.latitude
      );
      const currentMarker = new window.T.Marker(center);

      // Create custom icon for current location
      currentMarker.setIcon(new window.T.Icon({
        iconUrl: require('@/assets/images/location.png'),
        iconSize: new window.T.Point(24, 24),
        iconAnchor: new window.T.Point(12, 12)
      }));

      // Add marker to map
      map.value.addOverLay(currentMarker);
    };

    // const showRules = (coupon) => {
    //   selectedCoupon.value = coupon
    //   rulesDialogVisible.value = true
    // }

    const purchaseCoupon = async (coupon) => {
      try {
        const response = await purchaseCoupon(coupon.id)
        if (response.code === 200) {
          ElMessage.success('优惠券购买成功')
          // Update the local data if needed
        } else {
          ElMessage.error(response.msg || '购买失败，请稍后再试')
        }
      } catch (error) {
        console.error('Failed to purchase coupon:', error)
        ElMessage.error('购买失败，请稍后再试')
      }
    }

    // The existing receiveCoupon function remains for free coupons
    const receiveCoupon = async (coupon) => {
      try {
        loading.value = true;
        const response = await purchaseCoupon(coupon.id);

        if (response.code === 200) {
          ElMessage.success('领取成功');
          // No need to refresh the list after successful claim since we're using the component
        } else {
          ElMessage.error(response.msg || '领取失败');
        }
      } catch (error) {
        console.error('Error claiming coupon:', error);
        ElMessage.error('领取优惠券失败');
      } finally {
        loading.value = false;
      }
    };

    const viewMoreCoupons = (group) => {
      router.push({
        name: 'EntityCoupons',
        params: {
          businessType: group.businessType,
          entityId: group.busiEntityId
        }
      })
    }

    const showLocationPermissionDialog = () => {
      ElMessageBox.confirm(
        '需要位置权限来获取附近的优惠券。请允许浏览器获取位置权限。',
        '需要位置权限',
        {
          confirmButtonText: '我已允许',
          cancelButtonText: '稍后再说',
          type: 'warning',
        }
      ).then(() => {
        retryGetLocation();
      }).catch(() => {
        ElMessage.info('您可以稍后在页面底部点击"重试获取位置"按钮再次尝试');
      });
    };

    const getUserLocation = async () => {
      return new Promise((resolve) => {
        if (!navigator.geolocation) {
          ElMessage.warning('您的浏览器不支持位置服务');
          // Set a default mock location for Nanjing
          const mockLocation = {
            latitude: 31.9522,
            longitude: 118.7789
          };
          userLocation.value = mockLocation;
          resolve(mockLocation);
          return;
        }

        // Show loading indicator
        const loadingMsg = ElMessage.info({
          message: '正在获取位置信息...',
          duration: 0,
          showClose: true
        });

        const geoOptions = {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 0
        };

        navigator.geolocation.getCurrentPosition(
          (position) => {
            // Clear loading message
            loadingMsg.close();

            const location = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            };
            getAddressFromCoordinates(location.longitude,location.latitude)
            console.log('Got location successfully:', location);

            // Important: Update the reactive state directly
            userLocation.value = location;

            // Store in localStorage for debugging/backup
            localStorage.setItem('lastKnownLocation', JSON.stringify(location));

            resolve(location);
          },
          (error) => {
            // Clear loading message
            loadingMsg.close();

            console.error('Geolocation error:', error);
            let errorMsg = '获取位置失败';

            switch(error.code) {
              case 1: // PERMISSION_DENIED
                errorMsg = '位置权限被拒绝，请在设备设置中允许浏览器访问位置';
                break;
              case 2: // POSITION_UNAVAILABLE
                errorMsg = '当前位置信息不可用，请确保GPS已开启并尝试到室外开阔区域';
                break;
              case 3: // TIMEOUT
                errorMsg = '获取位置超时，请在网络良好区域重试';
                break;
            }

            ElMessage.warning({
              message: errorMsg,
              duration: 5000
            });

            // Try to use last known location from localStorage as fallback
            const lastLocation = localStorage.getItem('lastKnownLocation');
            if (lastLocation) {
              try {
                const parsed = JSON.parse(lastLocation);
                console.log('Using cached location:', parsed);
                userLocation.value = parsed; // Important: Update the reactive state
                resolve(parsed);
                return;
              } catch (e) {
                console.error('Error parsing cached location:', e);
              }
            }

            // If no cached location, use a default mock location for Nanjing
            const mockLocation = {
              latitude: 31.9522,
              longitude: 118.7789
            };
            console.log('Using default mock location for Nanjing:', mockLocation);
            userLocation.value = mockLocation;
            currentAddress.value = '南京市江宁区潭园西路128号';
            
            if (error.code === 1) { // PERMISSION_DENIED
              // Show permission dialog that uses ElMessageBox
              showLocationPermissionDialog();
            }

            resolve(mockLocation);
          },
          geoOptions
        );
      });
    };
    var T = window.T;

    const getAddressFromCoordinates=(lng, lat)=> {
      const geocoder = new T.Geocoder();
      geocoder.getLocation(new T.LngLat(lng, lat), (result) => {
        if (result.getStatus() === 0) {
          currentAddress.value= result.getAddress();
        } else {
          currentAddress.value= "未知";
        }
      });
    }

    const retryGetLocation = async () => {
      ElMessage.info('重新获取位置...');
      const newLocation = await getUserLocation();
      if (newLocation) {
        userLocation.value = newLocation;
        // Force refresh the discount list
        await refreshDiscountList();
      }
    };

    // Add method to refresh discount list
    const refreshDiscountList = async () => {
      // This will trigger the ParkingDiscounts component to refetch data
      console.log('Refreshing discount list with location:', userLocation.value);
      
      // Use the template ref to call the refresh method
      if (parkingDiscountsRef.value && parkingDiscountsRef.value.refreshData) {
        await parkingDiscountsRef.value.refreshData();
      } else {
        // Fallback: force a location change to trigger refresh
        const currentLocation = userLocation.value;
        userLocation.value = null;
        await new Promise(resolve => setTimeout(resolve, 100));
        userLocation.value = currentLocation;
      }
    };

    // Update the initialization function with ESLint disable comment
    const initializePage = async () => {
      // eslint-disable-next-line no-unused-vars
      userLocation.value = await getUserLocation();
      
      // Ensure we always have a location (either real or mock)
      if (!userLocation.value) {
        console.log('No location available, using default mock location');
        userLocation.value = {
          latitude: 31.9522,
          longitude: 118.7789
        };
        currentAddress.value = '南京市江宁区潭园西路128号';
      }
      
      console.log('Page initialized with location:', userLocation.value);
    };

    // Call initialization on mount
    onMounted(() => {
      initializePage();

      // Start countdown timer
      setInterval(() => {
        let seconds = parseInt(countdown.seconds)
        let minutes = parseInt(countdown.minutes)
        let hours = parseInt(countdown.hours)

        seconds--

        if (seconds < 0) {
          seconds = 59
          minutes--
        }

        if (minutes < 0) {
          minutes = 59
          hours--
        }

        if (hours < 0) {
          hours = 0
          minutes = 0
          seconds = 0
        }

        countdown.seconds = seconds.toString().padStart(2, '0')
        countdown.minutes = minutes.toString().padStart(2, '0')
        countdown.hours = hours.toString().padStart(2, '0')
      }, 1000)
    })

    // Add a function to get business type name based on type code
    const getBusinessTypeName = (type) => {
      // Convert numeric values from backend to string representations
      if (type === 1) return '停车';
      if (type === 2) return '充电';
      if (type === 3) return '洗车';
      if (type === 4) return '物业';

      // For string values (if already converted)
      if (type === 'parking') return '停车';
      if (type === 'charging') return '充电';
      if (type === 'washing') return '洗车';
      if (type === 'property') return '物业';

      return '通用';
    };

    // Get tag color based on business type
    const getBusinessTypeColor = (type) => {
      // Convert numeric values from backend
      if (type === 1) return '#3d8bfd';  // 停车 - Blue
      if (type === 2) return '#20c997'; // 充电 - Green
      if (type === 3) return '#fd7e14';  // 洗车 - Orange
      if (type === 4) return '#6f42c1'; // 物业 - Purple

      // For string values
      if (type === 'parking') return '#3d8bfd';
      if (type === 'charging') return '#20c997';
      if (type === 'washing') return '#fd7e14';
      if (type === 'property') return '#6f42c1';

      return '#adb5bd'; // Default - Gray
    };

    // Format remaining count
    const formatRemainingCount = (total, used) => {
      if (total === undefined || total === null) return '未知';
      const usedCount = used || 0;
      const remaining = total - usedCount;
      return `${remaining}/${total}`;
    };

    /**
     * Format discount value based on type
     * @param {string|number} value - The discount value to format
     * @param {string|number} type - The template type (1=cash, 2=percent, 7=hours)
     * @returns {string} - Formatted value
     */
    const formatDiscountValue = (value, type) => {
      // Debug to see what's being passed
      console.log(`Formatting discount value: ${value}, type: ${type}`);

      // Handle null, undefined or empty values
      if (value === null || value === undefined || value === '') {
        return '0';
      }

      // Try multiple property names (API inconsistency fix)
      let numValue;
      if (typeof value === 'object') {
        // If it's an object, try to extract the value from it
        numValue = parseFloat(value.value || value.amount || Object.values(value)[0] || 0);
      } else {
        // Convert to number if it's a string or number
        numValue = parseFloat(value);
      }

      // Handle NaN
      if (isNaN(numValue)) {
        console.warn('Could not parse discount value:', value);
        return '0';
      }

      const typeId = parseInt(type);

      switch(typeId) {
        case 1: // Cash amount
          return numValue.toFixed(2);
        case 2: // Percentage discount
          return numValue.toFixed(1);
        case 3: // Hours
          return numValue.toString();
        default:
          return numValue.toFixed(2); // Default to 2 decimal places for money values
      }
    };
    /**
     * Get the unit label based on template type
     * @param {string|number} type - The template type
     * @returns {string} - Unit label
     */
    const formatDiscountUnit = (type) => {
      switch (type) {
        case '1': return '元';
        case '2': return '小时';
        case '3': return '折';
        default: return '';
      }
    };

    // Either remove the processCouponData variable if it's not needed
    // const processCouponData = ...

    // OR add an eslint-disable comment if you want to keep it for later
    // eslint-disable-next-line no-unused-vars
    // const processCouponData = (coupons) => {
    //   return coupons.map(item => {
    //     // Use getCouponTypeFromTemplate for processing
    //     const type = getCouponTypeFromTemplate(item);
    //     // Use getCouponValueFromTemplate for processing
    //     const value = getCouponValueFromTemplate(item);
    //     // Use formatDistance for display
    //     const displayDistance = item.distance ? formatDistance(item.distance) : '';
    //
    //     return {
    //       id: item.id,
    //       templateId: item.templateId,
    //       templateName: item.name,
    //       templateType: type,
    //       templateValue: value,
    //       businessType: item.businessType,
    //       busiEntityId: item.busiEntityId,
    //       busiEntityName: item.busiEntityName || '未知场所',
    //       quantity: item.quantity,
    //       usedQuantity: item.usedQuantity || item.successCount || 0,
    //       distance: displayDistance,
    //       distributionType: item.distributionType,
    //       validStartTime: item.validStartTime,
    //       validEndTime: item.validEndTime,
    //       distributionPrice: item.distributionPrice
    //
    //     };
    //   });
    // };

    const handleCouponAction = (coupon) => {
      console.log('Parent component handleCouponAction called with:', coupon);

      if (!coupon) {
        console.error('No coupon data provided');
        return;
      }

      console.log('Coupon details:', {
        id: coupon.id,
        price: coupon.distributionPrice,
        name: coupon.name
      });

      try {
        // For free coupons (price is 0)
        if (!coupon.distributionPrice || parseFloat(coupon.distributionPrice) === 0) {
          receiveCoupon(coupon);
        }
        // For paid coupons (price > 0)
        else {
          console.log('Router instance:', router);
          console.log('Navigating to payment confirmation with query:', {
            packageId: coupon.id, // Using packageId as the generic ID field
            name: coupon.name || '优惠券',
            price: coupon.distributionPrice,
            type: 'coupon',
            businessType: coupon.businessType,
            templateType: coupon.templateType,
            templateValue: coupon.templateValue || coupon.discountValue,
            busiEntityName: coupon.busiEntityName,
            busiEntityId: coupon.templateId,
          });

          console.log("buubu" + JSON.stringify(coupon))

          // For parking-related coupons (businessType === 1), busiEntityId is the parkingSpaceId
          const parkingSpaceId = (coupon.businessType === 1 && coupon.busiEntityId) 
            ? coupon.busiEntityId 
            : null;

          // Use the router to navigate
          router.push({
            name: 'PaymentConfirm',
            query: {
              packageId: coupon.id, // Using packageId as the generic ID field
              name: coupon.name || '优惠券',
              price: coupon.distributionPrice,
              type: 'coupon',
              businessType: coupon.businessType,
              templateType: coupon.templateType,
              templateValue: coupon.templateValue || coupon.discountValue,
              busiEntityName: coupon.busiEntityName,
              busiEntityId: coupon.templateId,
              parkingSpaceId: parkingSpaceId, // Add parkingSpaceId for parking coupons
            }
          });
        }
      } catch (error) {
        console.error('Error handling coupon action:', error);
      }
    };

    return {
      loading,
      // flashSaleCoupons,
      nearbyCoupons,
      currentAddress,
      countdown,
      timeSlots,
      nextRoundTime,
      // groupedCoupons,
      rulesDialogVisible,
      // selectedCoupon,
      userLocation,
      formatCouponValue,
      getCouponTypeClass,
      getCouponTypeColor,
      getCouponBusinessClass,
      getBusinessLabel,
      getCouponTag,
      formatDate,

      goBack,
      goToSearch,
      isMapView,
      setMapView,
      searchText,
      parkingSearch,
      // showRules,
      purchaseCoupon,
      receiveCoupon,
      viewMoreCoupons,
      retryGetLocation,
      isDevelopment,
      getBusinessTypeName,
      getBusinessTypeColor,
      formatRemainingCount,
      formatDiscountValue,
      formatDiscountUnit,
      // refreshKey
      // handleCouponAction
      handleCouponAction,
      refreshDiscountList,
      parkingDiscountsRef
    }
  }
}
</script>

<style scoped>

.discount-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f5f5f5;
}

/* Header */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  background-color: white;
}

.back-button, .more-button {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.title {
  font-size: 18px;
  font-weight: bold;
}

.website {
  text-align: center;
  padding: 5px;
  color: #999;
  font-size: 12px;
  background-color: white;
  border-bottom: 1px solid #eee;
}

/* Limited Time Offers */
.limited-offers {
  background-color: white;
  margin-bottom: 10px;
  padding: 15px;
}

.offer-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.offer-label {
  color: #ff4a4a;
  font-weight: bold;
  margin-right: 10px;
  background: linear-gradient(to right, #ff6034, #ee0a24);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.countdown {
  display: flex;
  align-items: center;
}

.countdown-number {
  background-color: #ee0a24;
  color: white;
  border-radius: 4px;
  padding: 2px 4px;
  font-size: 14px;
}

.countdown-separator {
  margin: 0 2px;
  color: #ee0a24;
}

.next-round {
  margin-left: 10px;
  color: #ee0a24;
  font-size: 14px;
}

.time-slots {
  display: flex;
  justify-content: space-around;
  margin-bottom: 15px;
}

.time-slot {
  text-align: center;
}

.time {
  font-size: 16px;
  font-weight: bold;
}

.status {
  font-size: 12px;
  color: #999;
}

/* Coupon Cards */
.coupon-container {
  display: flex;
  overflow-x: auto;
  padding-bottom: 10px;
}

.coupon-card {
  flex: 0 0 auto;
  width: 170px;
  background-color: #fff9f3;
  border-radius: 8px;
  padding: 10px;
  margin-right: 10px;
  position: relative;
  border: 1px solid #ffcfbd;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.coupon-tag {
  position: absolute;
  top: 0;
  left: 0;
  padding: 4px 8px;
  color: white;
  font-size: 12px;
  border-top-left-radius: 4px;
  border-bottom-right-radius: 8px;
  z-index: 1;
}

.rules-link {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #999;
  font-size: 12px;
}

.value-number {
  font-size: 30px;
  font-weight: bold;
}

.value-quantity {
  font-size: 30px;
  font-weight: bold;
}

.coupon-desc {
  font-size: 12px;
  color: #666;
  margin-top: 5px;
}

.grab-button {
  background: linear-gradient(to right, #ff6034, #ee0a24);
  color: white;
  text-align: center;
  border-radius: 20px;
  padding: 6px 0;
  margin-top: 10px;
  font-size: 14px;
  font-weight: bold;
}

/* Search Bar */
.search-container {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  background-color: white;
}

.search-box {
  flex: 1;
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 20px;
  padding: 8px 15px;
  margin-right: 10px;
}

.search-placeholder {
  color: #999;
  margin-left: 10px;
  font-size: 14px;
}

.map-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  color: #666;
}

/* Location Info */
.location-info {
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #666;
  font-size: 14px;
}

.location-left {
  display: flex;
  align-items: center;
}

.location-left .el-icon {
  margin-right: 5px;
  color: #999;
}

.location-right {
  text-align: right;
  color: #999;
  font-size: 12px;
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Section Title */
.section-title {
  padding: 10px 15px;
  font-size: 12px;
  text-align: right;
  font-weight: bold;
}

/* Coupon List */
.nearby-coupons {
  padding: 15px;
}

.coupon-list {
  margin-top: 10px;
}

.coupon-item {
  position: relative;
  background-color: white;
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.coupon-content {
  padding-top: 5px;
}

.coupon-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 12px;
}

.coupon-name {
  font-size: 16px;
  font-weight: bold;
  flex: 1;
  padding-right: 10px;
}

.coupon-amount {
  color: #f56c6c;
}

.coupon-info {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
  font-size: 16px;
  color: #171718e3;
}

.coupon-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}

.coupon-value {
  font-size: 24px;
  font-weight: bold;
  color: #f56c6c;
}
.amount-unit {
  font-size: 12px;
  font-weight: bold;
  color: #319bf1;
}
.coupon-details {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr; /* Two equal columns */
  align-items: center;
  width: 100%;
}

.amount-price {
  color: #409eff;
}

.coupon-remaining {
  font-size: 12px;
  color: #909399;
  text-align: center;
}

.business-info {
  display: flex;
}

.coupon-action {
  margin-top: 12px;
  text-align: right;
}

.empty-state {
  margin-top: 40px;
  margin-bottom: 40px;
}

/* Add new classes for coupon types */
.coupon-cash {
  background-color: #fff9f3;
  border: 1px solid #ffcfbd;
}

.coupon-percent {
  background-color: #f0f9ff;
  border: 1px solid #c6e2ff;
}

.coupon-duration {
  background-color: #f3fff0;
  border: 1px solid #c9efc6;
}

.discount-cash {
  color: #ff6034;
}

.discount-percent {
  color: #007aff;
}

.discount-duration {
  color: #09bb07;
}

.business-parking {
  background-color: #007aff;
}

.business-charging {
  background-color: #09bb07;
}

.business-washing {
  background-color: #ff9500;
}

/* Add loading and empty states */
.loading-state, .empty-state {
  padding: 20px;
  text-align: center;
  color: #999;
}

.debug-panel {
  padding: 10px;
  background-color: white;
  border-top: 1px solid #f5f5f5;
}

.validity, .distance, .address {
  display: block;
  width: 100%;
  text-align: center;
  margin: 4px 0;
  color: #333; /* Make sure text is visible */
}

/* Target the purchase buttons and change their background color to blue */
.coupon-purchase,
button.purchase,
.btn-purchase,
.buy-button {
  background-color: #1890ff !important; /* Blue color, using !important to override existing styles */
  color: white !important;
  border-color: #1890ff !important;
}

/* If you can inspect and find the exact class name, use that instead */
/* Example if the buttons have a specific class */
.coupon-action .el-button,
.purchase-btn {
  background-color: #1890ff !important;
  color: white !important;
  border-color: #1890ff !important;
}

.map-container {
  height: 250px;
  width: 100%;
  position: relative;
  z-index: 1; /* Ensure it's not covered by other elements */
  pointer-events: auto; /* Explicitly enable pointer events */
}
.hidden {
  display: none;
}
.view-toggle {
  display: flex;
  gap: 10px;
  text-align: center;
}
.view-toggle img {
  cursor: pointer;
}
.icon-label{
  font-size: 12px;
  margin-top: -3px;
}

.search-input {
  flex: 1;
  border: none;
  background: transparent;
  height: 100%;
  font-size: 14px;
  width: 150px;
}
.search-input:focus {
  outline: none;
}
.search-button {
  background-color: #4080ff;
  color: white;
  padding: 4px 6px;
  border-radius: 15px;
  font-size: 12px;
}
</style>
